import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  overlay: {
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    position: 'fixed',
    background: 'rgba(0,0,0,0.4)',
  },
  dialog: {
    [theme.breakpoints.down('sm')]: {
      left: 0,
      top: '10%',
      borderRadius: 3,
      transform: 'translateY(0%)',
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      marginBottom: theme.spacing(2),
      width: `calc(100% - ${theme.spacing(2)}px)`,
    },

    top: '50%',
    transform: 'translateY(-50%)',
    width: '1000px',
    maxHeight: `calc(90% - ${theme.spacing(2)}px)`,
    position: 'fixed',
    background: '#F2F2F2',
    left: 'calc((100% - 1000px) / 2)',
    boxShadow: '0 0 20px 0px rgba(0,0,0,0.4)',
    overflowY: 'auto',
  },
}));
